<template>
  <div>
    <div class="bgc" v-if="innerWidth > 768 && !ispad">
      <div class="left_img_box" :style="{ width: (innerWidth - 523 )/ 2  + 'px'}">
        <img :style="{
          width: (innerWidth - 600 )/ 2 - 200 + 'px',
        }" src="@/assets/image/h5img/hleft.png" class="left_img"></img>
      </div>
      <div class="right_img_box" :style="{ width: (innerWidth - 523 )/ 2  + 'px'}">
        <img :style="{
          width: (innerWidth - 600 )/ 2 -50 + 'px',
         }" src="@/assets/image/h5img/hright.png" class="right_img"></img>
      </div>
    </div>
    <div class="bgc" v-else-if="innerWidth >= 768" :style="{
      backgroundImage: `url(${require('@/assets/image/h5img/hbg1.jpg')})`
    }"></div>
    <dow-box v-if="isSdk"></dow-box>
    <div class="layoutmain" @click="sdkclick">
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive"></router-view>
    </div>
    <sdkdow-btn v-if="isSdk"></sdkdow-btn>

    <div v-if="innerWidth < 768 || ispad" class="fslink" :class="{ 'drawer-open': isDrawerOpen }">
      <div class="ios_pop" v-if="!$isApp()">
        <div class="drawer">
          <img @click.stop.prevent="toggleDrawer(false)" class="close-icon" src="@/assets/image/h5img/close_con.png" alt="">
          <div class="drawer-content">
            <img @click.stop.prevent="openLink" src="@/assets/image/h5img/33.png" alt="">
          </div>
          <div @click.stop.prevent="openLink" class="drawer-text">app下载</div>
        </div>
      </div>
    </div>
    <van-popup class="downpoup" v-model="showfirst" position="center">
      <div class="popbox">
        <img @click="tolink" src="@/assets/image/h5img/hd.png" alt="">
        <single-button @know="tolink" style="position: absolute;bottom: 2.3rem;left: 50%;transform: translateX(-50%);" text="开启全新体验" width="10rem" height="2rem" :background="'linear-gradient( 180deg, #FFEAB3 0%, #FFD97D 100%) !important'" color="#1D1D1D"></single-button>
      </div>
      <div class="popboxbtn" @click="showfirst = false">
        <img src="@/assets/image/icon/tcclose.png" alt="">
      </div>
    </van-popup>

    <div :style="{
      maxWidth: (innerWidth - 523 )/ 2 - 50  + 'px',
      right: (innerWidth - 523 )/2 + 523 + 30 + 'px',
    }" class="pc_left" v-if="innerWidth > 768 && !ispad">
      <img style="width: 90%;max-width: 300px; margin-top: 15px;margin-left: 15px;" src="@/assets/image/h5img/ss.png" alt="">
      <div class="downboxPcLeft" style="">
        <div class="dobox dobox1" @click="toDown('android')">
          安卓版下载
        </div>
        <div class="dobox dobox2" @click="toDown('ios')">
          苹果版下载
        </div>
      </div>
    </div>

    <div :style="{
      maxWidth: (innerWidth - 523 )/ 2 - 50  + 'px',
    }" class="pc_right" v-if="innerWidth > 768 && !ispad">
      <div class="downboxPc" style="">
        <img style="width: 100%;" src="@/assets/image/h5img/dow.png" alt="">
      </div>
      <div class="boxPc2">
        <p>公安网备案号：32028102000727</p>
        <p>互联网文化许可证编号：<span @click="gotoicp(1)">苏网文〔2018〕8104-142号</span></p>
        <p>信息产业部备案号：<span @click="gotoicp(2)">苏ICP备16021564号-28</span></p>
        <p>广播电视节目制作经营许可证编号：<span @click="gotoicp(3)">(苏)字第03385号</span></p>
        <p>江苏三九互娱网络技术有限公司 版权所有</p>
        <p>运营单位：江苏三九互娱网络科技有限公司</p>
      </div>
    </div>

    <yuyue-popup :open="isMobileCofirm.yuyue" @func="isMobileCofirm.yuyueFunc()"></yuyue-popup> <!-- 预约游戏弹窗 -->
    <gameBind :open="pagePopupData&&pagePopupData.show" :data="pagePopupData.data"></gameBind>
    <downqrcode-popup ref="downqrcodePopup"></downqrcode-popup>
    <topic-win-popup :show="pagePopupData&&pagePopupData.showTopicWin" :data="pagePopupData.data"></topic-win-popup> <!-- 帖子活动中奖弹窗 -->
    <down-activity-popup :show="pagePopupData&&pagePopupData.showDownActivity"></down-activity-popup> <!-- APP专属活动下载弹窗 -->

  </div>
</template>

<script>
import dowBox from '@/pages/sdkpage/dowBox.vue';
import SdkdowBtn from '@/pages/sdkpage/sdkdowBtn.vue';
import DownqrcodePopup from './components/downqrcodePopup.vue';
import { baseURL } from '@/ajax';
import { downLoadUrl } from '@/utils/down'
import TopicWinPopup from '@/pages/community/pages/components/topicWinPopup.vue';
import DownActivityPopup from '@/pages/activity/template/components/downActivityPopup.vue';
export default {
  components: { dowBox, SdkdowBtn, DownqrcodePopup, TopicWinPopup, DownActivityPopup },
  name: 'VueNew39main',

  computed: {
    isSdk() {
      return this.$isSdk() && this.isBox
    },
    isBox() {
      return this.$route.path != '/pages/sdkpage/index' && this.$route.path != '/pages/community/pages/topicDetail' && this.$route.path != '/pages/daySignin/daySignin' && this.$route.path != '/pages/community/pages/answer'
    },
    isMobileCofirm() {
      return this.$store.state.popup.isMobileCofirm
    },
    pagePopupData() {
      return this.$store.state.popup.pagePopupData
    },
    ispad() {
      const userAgent = navigator.userAgent.toLowerCase();
      // iPad 检测
      const isIPad = /ipad/.test(userAgent) ||
        (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
      // Android 平板检测
      const isAndroidTablet = /android/.test(userAgent) && !/mobile/.test(userAgent);
      // Windows 平板检测
      const isWindowsTablet = /windows/.test(userAgent) && /touch/.test(userAgent) &&
        !/phone/.test(userAgent);
      // 其他平板检测
      const isOtherTablet = /tablet/.test(userAgent) ||
        /kindle/.test(userAgent) ||
        /playbook/.test(userAgent) ||
        /silk/.test(userAgent);
      return isIPad || isAndroidTablet || isWindowsTablet || isOtherTablet;
    }
  },

  data() {
    return {
      showfirst: false,
      isDrawerOpen: false,
      innerWidth: window.innerWidth,
      downLink: '',
    };
  },

  mounted() {
    // 添加节流函数
    const throttle = (fn, delay) => {
      let lastCall = 0;
      return function (...args) {
        const now = new Date().getTime();
        if (now - lastCall >= delay) {
          lastCall = now;
          return fn.apply(this, args);
        }
      };
    };

    // 使用节流函数包装resize事件处理
    const handleResize = throttle(() => {
      this.innerWidth = window.innerWidth;
      this.$store.commit('setInnerWidth', this.innerWidth)
      setVh()
    }, 200); // 200毫秒的节流时间
    function setVh() {
      // 获取视口高度
      let vh = window.innerHeight * 0.01;
      // 设置CSS变量
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    }
    window.addEventListener('resize', handleResize);
    window.addEventListener('orientationchange', setVh);

    // 保存引用以便在组件销毁时移除
    this._handleResize = handleResize;
    // 监听downboxPc的高度变化
    this.$nextTick(() => {
      const downboxPc = document.querySelector('.downboxPc');
      const boxPc2 = document.querySelector('.downboxPcLeft');
      if (downboxPc && boxPc2) {
        const observer = new ResizeObserver(entries => {
          for (let entry of entries) {
            const { height, width } = entry.contentRect;
            boxPc2.style.height = `${height}px`;
            boxPc2.style.width = `${width}px`;
          }
        });
        observer.observe(downboxPc);
      }
    });
  },

  methods: {
    toDown(platform) {
      const advertisingId = localStorage.getItem('advertisingId')
      console.log(advertisingId);
      window.location.href = baseURL + `/common/appDownloadLink?platform=${platform}&advertisingId=${advertisingId}`
    },
    gotoicp(type) {
      switch (type) {
        case 1:
          window.open('http://ccm.mct.gov.cn/ccnt/sczr/service/business/emark/toDetail/fa32eb2bba5f4d7eb3e574d756332d8b')
          break;
        case 2:
          window.open('https://beian.miit.gov.cn/')
          break;
        case 3:
          window.open(baseURL + `/images/zizhi.png`)
          break;
      }
    },
    sdkclick() {
      if (this.isSdk) {
        this.$downPopup();
      }
    },
    tolink() {
      this.downLink = downLoadUrl()
      console.log(this.downLink)
      window.open(this.downLink)
    },
    // 切换抽屉状态
    toggleDrawer(status) {
      this.isDrawerOpen = status;
      console.log(status ? '打开抽屉' : '关闭抽屉', this.isDrawerOpen);
    },
    // 添加打开链接的方法
    openLink() {
      if (!this.isDrawerOpen) {
        this.isDrawerOpen = true
        return
      }
      this.showfirst = true
    }
  },
  watch: {
    $route: {
      handler(val) {
        if (val.path == '/pages/yun/yun' && this.$device().isPC) {
          this.$refs.downqrcodePopup.open()
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.layoutmain {
  background: #f8f8f8;
  min-height: calc(var(--vh, 1vh) * 100);
}
.pc_right {
  position: relative;
  z-index: 1;
  position: fixed;
  left: calc(50% + 300px);
  bottom: 30px;
  z-index: 1;
  .boxPc2 {
    margin-top: 20px;
    font-size: 14px;
    color: #fff4d9;
    line-height: 25px;
    p {
      span {
        text-decoration: underline;
        cursor: pointer;
      }
    }
  }
}
.pc_left {
  position: fixed;
  bottom: 20%;
  margin-left: 10px;
  background-image: url("@/assets/image/h5img/bbaa.png");
  background-size: 100% 100%;
}
.downboxPcLeft {
  width: 100%;
  display: flex;
  padding: 10px;
  justify-content: space-between;
  position: relative;
  .dobox {
    width: 49%;
    background: #ffffff;
    box-shadow: 0px 3px 3px 1px rgba(255, 230, 168, 0.77);
    border-radius: 11px 11px 11px 11px;
    color: #855200;
    display: flex;
    justify-content: center;
    align-items: flex-end;
    font-size: 20px;
    padding-bottom: 3%;
    cursor: pointer;
  }
  .dobox1 {
    &::after {
      content: "";
      width: 15%;
      height: 70%;
      background-image: url("@/assets/image/h5img/an.png");
      background-size: cover;
      position: absolute;
      top: 12%;
    }
  }
  .dobox2 {
    &::after {
      content: "";
      width: 12%;
      height: 80%;
      background-image: url("@/assets/image/h5img/p1.png");
      background-size: cover;
      position: absolute;
      top: 10%;
    }
  }
  .dobox1:hover {
    &::after {
      content: "";
      width: 15%;
      height: 70%;
      background-image: url("@/assets/image/h5img/an1.png");
      background-size: cover;
    }
  }
  .dobox2:hover {
    &::after {
      content: "";
      width: 12%;
      height: 80%;
      background-image: url("@/assets/image/h5img/p2.png");
      background-size: cover;
    }
  }
}
.downboxPc {
  max-width: 537px;
  .qrcode-container {
    width: 148px;
    height: 148px;
    margin-right: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .qrcode-img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  .download-info {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
  .download-title {
    font-size: 27px;
    font-weight: bold;
    color: #000;
    margin-bottom: 15px;
  }
  .download-buttons {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }
  .download-btn {
    width: calc(50% - 5px);
    height: 40px;
    background: linear-gradient(180deg, #1d1d1d 0%, #5b4e3f 100%);
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #f3d873;
    cursor: pointer;
    transition: all 0.3s;
    font-size: 18px;
  }
  .download-btn:hover {
    opacity: 0.9;
  }
  .download-btn img {
    width: 20px;
    height: 20px;
    margin-right: 5px;
  }
  .game-btn {
    background-color: #8e5e26;
  }
  .activity-btn {
    background-color: #8e5e26;
  }
  .game-feature-btn {
    background-color: #8e5e26;
  }
  .cloud-btn {
    background-color: #8e5e26;
  }
}
.bgc {
  position: fixed;
  left: 0;
  width: 100%;
  background-image: url("@/assets/image/h5img/hbg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center;
  height: calc(var(--vh, 1vh) * 100);
  overflow: hidden;
  z-index: -1;
  display: flex;
  justify-content: space-between;
  .left_img_box,
  .right_img_box {
    display: flex;
    justify-content: center;
    display: grid;
    grid-template-rows: max-content; /* 或者用 auto */
  }
  .left_img,
  .right_img {
    width: 200px;
    margin-top: 61px;
  }
  .left_img {
    max-width: 380px;
    min-width: 200px;
  }
  .right_img {
    max-width: 550px;
    min-width: 300px;
  }
}
.fslink {
  position: fixed;
  right: 0;
  bottom: 10rem;
  z-index: 999;
  transform: translateX(calc(100% - 1.5rem)); /* 默认只显示一小部分 */
  transition: transform 0.3s ease; /* 平滑过渡效果 */
  &.drawer-open {
    transform: translateX(0); /* 完全显示 */
  }
  .drawer {
    display: flex;
    align-items: center;
    position: relative;
    height: 1.3rem;
    background-color: rgba(0, 0, 0, 0.7);
    border-radius: 1rem 0 0 1rem;
    padding-left: 0.1rem;
    padding-right: 0.2rem;
    color: #e6be30;
    font-size: 0.6rem;
    // transform: translateX(calc(100% - 1.5rem)); /* 默认只显示一小部分 */
    // transition: transform 0.3s ease; /* 平滑过渡效果 */

    .close-icon {
      width: 0.8rem;
      position: absolute;
      top: -0.95rem;
      left: 1.8rem;
      cursor: pointer;
    }

    .drawer-content {
      height: 100%;
      text-align: end;
      margin-right: 0.2rem;
      margin-left: 0.25rem;

      img {
        width: 1rem;
        height: 1rem;
        margin-top: 0.15rem;
        cursor: pointer;
      }
    }

    .drawer-text {
      margin-right: 0.2rem;
    }
  }
}
.downpoup {
  overflow: inherit;
  background: transparent;
  .popbox {
    img {
      width: 375px;
    }
  }
  .popboxbtn {
    img {
      width: 1rem;
      height: 1rem;
      position: absolute;
      bottom: -3rem;
      left: 50%;
      transform: translateX(-50%);
    }
  }
}
</style>